var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.id === 'feralco')?[_c('FeralcoOrdersList',{attrs:{"id":_vm.id}})]:(_vm.id === 'feralcoIntern')?[_c('FeralcoInternOrdersList',{attrs:{"id":_vm.id}})]:(_vm.id === 'container')?[_c('ContainerOrdersList',{attrs:{"id":_vm.id}})]:[_c('StandardOrdersList',{attrs:{"id":_vm.id,"customer":_vm.customer}})]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8869fa04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/OrderListByType.vue
// module id = null
// module chunks = 